import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { AppProvider } from "@/context/AppContext";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import Cart from "@/pages/Cart";
import CheckoutResult from "@/pages/CheckoutResult";
import IDCardBuilder from "@/pages/IDCardBuilder";
import EmergencyProfile from "@/pages/EmergencyProfile";
import Resources from "@/pages/Resources";
import Insurance from "@/pages/Insurance";
import Donate from "@/pages/Donate";
import Fundraisers from "@/pages/Fundraisers";
import StartFundraiser from "@/pages/StartFundraiser";
import FundraiserDetail from "@/pages/FundraiserDetail";
import Membership from "@/pages/Membership";
import CommunityOutreach from "@/pages/CommunityOutreach";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";

function RootRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/shop" element={<Shop />} />
        <Route path="/shop/:category" element={<Shop />} />
        <Route path="/product/:pid" element={<ProductDetail />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/checkout/result" element={<CheckoutResult />} />
        <Route path="/id-card" element={<IDCardBuilder />} />
        <Route path="/emergency/:cardId" element={<EmergencyProfile />} />
        <Route path="/resources" element={<Resources />} />
        <Route path="/insurance" element={<Insurance />} />
        <Route path="/donate" element={<Donate />} />
        <Route path="/fundraisers" element={<Fundraisers />} />
        <Route path="/fundraisers/new" element={<StartFundraiser />} />
        <Route path="/fundraisers/:fid" element={<FundraiserDetail />} />
        <Route path="/membership" element={<Membership />} />
        <Route path="/community" element={<CommunityOutreach />} />
        <Route path="/login" element={<Login />} />
        <Route path="/dashboard" element={<Dashboard />} />

        {/* SEO-friendly alias routes */}
        <Route path="/autism-id-card-generator" element={<Navigate to="/id-card" replace />} />
        <Route path="/special-needs-emergency-id-card" element={<Navigate to="/id-card" replace />} />
        <Route path="/autism-safety-resources" element={<Navigate to="/resources" replace />} />
        <Route path="/aba-therapy-resources" element={<Navigate to="/resources" replace />} />
        <Route path="/autism-schools-directory" element={<Navigate to="/resources" replace />} />
        <Route path="/autism-hospitals-and-clinics" element={<Navigate to="/resources" replace />} />
        <Route path="/autism-insurance-assistance" element={<Navigate to="/insurance" replace />} />
        <Route path="/autism-fundraisers" element={<Navigate to="/fundraisers" replace />} />
        <Route path="/autism-donations" element={<Navigate to="/donate" replace />} />
        <Route path="/aac-devices-and-tablets" element={<Navigate to="/shop/aac-speech" replace />} />
        <Route path="/autism-sensory-products" element={<Navigate to="/shop/sensory-tools" replace />} />
        <Route path="/autism-clothing" element={<Navigate to="/shop/autism-clothing" replace />} />
        <Route path="/autism-bedding" element={<Navigate to="/shop/bedding" replace />} />
        <Route path="/autism-books-and-games" element={<Navigate to="/shop/educational-books" replace />} />
        <Route path="/feeding-therapy-products" element={<Navigate to="/shop/food-therapy" replace />} />
        <Route path="/autism-mobility-support" element={<Navigate to="/shop/mobility" replace />} />
        <Route path="/autism-sports-programs" element={<Navigate to="/shop/sports-gear" replace />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <AppProvider>
      <div className="App">
        <BrowserRouter>
          <RootRouter />
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </div>
    </AppProvider>
  );
}

export default App;
